import React, { Component } from 'react';
import PropTypes from 'prop-types';


import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';

const s:any = {
  bannermaster: {
    marginLeft: 10,
  },
  bannerbox:{
    height: 300,
    width: 400,
    backgroundImage: 'url(lib/img/wcm2.png)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: '0 50%',
    backgroundColor: 'transparent',
    //marginBottom: 100,

    borderRadius:'15px 0 0 0',
  },
  messagebox:{
    width: 400,
    backgroundSize: 'cover',
    backgroundColor: 'primary.main',
    //paddingLeft: 10,
    flexDirection: 'vertical',
    alignItems: 'baseline',
    flex:1
  },
  titlebar: {
    display: 'flex',
    paddingLeft: 10,
  },
  first: {
    color: '#FFC60B',
  },
  last: {
    color: '#FFffFF',
  },
  title: {
    color: '#FFC60B',
  },
  subtitlebar: {
    paddingLeft: 10,
  },
  subtitle: {
    color: '#FFC60B',
  },
  messagebar: {
    paddingLeft: 10,
  },
  message: {
    color: '#FFFFFF',
  },
  textField: {
    marginLeft: 'spacing(1)',
    marginRight: 'spacing(1)',
    //width: 200,
  },
  hide:{
    display:'none',
  },
}

class LoginBanner extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      next: true,
      value: this.props.value 
    };
  }

  splitline = (line:string) => {
    const chunks = String(line).split(/\s+/);
    const [first,last] = [chunks.shift(), chunks.join(' ')];
    return {first,last};
  }

  render() {
    const {id,label,divider,item,classes } = this.props;
    const {first,last} = this.splitline(item.title);
    return (
      <Box sx={{...s.master00}}>
        <Box sx={{...s.bannerbox}} style={{backgroundImage: `url(${item.photo})`}}>
          {/* <!-- Left Panel --> */}
        </Box>
        <Box sx={{...s.messagebox}}>
          <Box sx={{...s.titlebar}}>
            <Typography sx={{...s.first}} variant="h5" component="h5">{first}</Typography>&nbsp;
            <Typography sx={{...s.last}} variant="h5" component="h5">{` ${last}`}</Typography>
          </Box>
          <Box sx={{...s.subtitlebar}}>
            <Typography sx={{...s.subtitle}} variant="subtitle1" component="span">{item.subtitle}</Typography>
          </Box>
          <Box sx={{...s.messagebar}}>
            <Typography sx={{...s.message}} variant="body1" component="div">{item.message}</Typography>
          </Box>
        </Box>
      </Box>
    );
  }
}

LoginBanner.propTypes = {
  classes: PropTypes.object.isRequired,
  //id: PropTypes.string.isRequired,
  //label: PropTypes.string.isRequired,
};

export default LoginBanner;
